<template>
  <div id='route-tree'>
    <div id='tree'>
      <div class='entry'>
        <span class='bg-3v3'>
          <strong>CIR</strong>
        </span>
        <node :item='root' />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'route-tree',
  props: {
    eqp: String,
    connections: Array
  },
  data () {
    return {
      elements: [],
      root: {
        children: [],
        bg: '3v3'
      }
    }
  },
  mounted() {
    this.organizeList(this.connections);
  },
  watch: {
    connections() {
      this.organizeList(this.connections);
    }
  },
  methods: {
    organizeList(list) {
      let root = {
        bg: this.root.bg,
      }
      root.children = this.mapPerParent(list, 0);
      root.SON = !!list.filter(e => e.NEIGHBOR == 0).length;
      this.root = root;
    },
    mapPerParent(list, parent) {
      let result = [];
      list.map(e => {
        if (e.NEIGHBOR == parent) {
          let item = {
            NEIGHBOR: e.NEIGHBOR,
            ADDR: e.ADDR,
            SON: e.SON,
            bg: e.bg,
            children: this.mapPerParent(list, e.ADDR)
          };
          result.push(item);
        }
      });
      return result;
    }
  }
}
</script>


<style>
  #tree {
    display: inline-block;
    padding: 0px;
  }

  #tree * {
    box-sizing: border-box;
  }

  #tree .branch {
    padding: 5px 0 5px 20px;
  }

  #tree .branch:not(:first-child) {
    margin-left: 110px;
  }

  #tree .branch:not(:first-child):after {
    content: "";
    width: 65px;
    border-top: 1px solid var(--orange-color);
    position: absolute;
    left: 45px;
    top: 50%;
    margin-top: 1px;
  }

  .entry {
    position: relative;
    min-height: 50px;
    display: block;

  }

  .entry:before {
    content: "";
    height: 100%;
    border-left: 1px solid var(--orange-color);
    position: absolute;
    left: -20px;
  }

  .entry:first-child:after {
    height: 10px;
    border-radius: 10px 0 0 0;
  }

  .entry:first-child:before {
    width: 10px;
    height: 50%;
    top: 50%;
    margin-top: 1px;
    border-radius: 10px 0 0 0;
  }

  .entry:after {
    content: "";
    width: 20px;
    transition: border 0.5s;
    border-top: 1px solid var(--orange-color);
    position: absolute;
    left: -20px;
    top: 50%;
    margin-top: 1px;
  }

  .entry:last-child:before {
    width: 10px;
    height: 50%;
    border-radius: 0 0 0 10px;
  }
  .entry:last-child:after {
    height: 10px;
    border-top: none;
    transition: border 0.5s;
    border-bottom: 1px solid var(--orange-color);;
    border-radius: 0 0 0 10px;
    margin-top: -9px;
  }

  .entry:only-child:after {
    width: 20px;
    height: 0px;
    margin-top: 1px;
    border-radius: 0px;
  }

  .entry:only-child:before {
    display: none;
  }

  .entry span {
    border: 1px solid #4f4f4f;
    display: block;
    width: 45px;
    height: 45px;
    padding: 11px 10px;
    line-height: 20px;
    text-align: center;
    position: absolute;
    left: 0;
    top: 50%;
    margin-top: -20px;
    color: #fff;
    font-family: arial, verdana, tahoma;
    font-size: 14px;
    display: inline-block;
    border-radius: 3px;
    transition: all 0.5s;
  }

  #tree .entry span:hover,
  #tree .entry span:hover + .branch .entry span {
    background: #333333;
    color: #000;
    border-color: #333333;
  }

  #tree .entry span:hover + .branch .entry::after,
  #tree .entry span:hover + .branch .entry::before,
  #tree .entry span:hover + .branch::before,
  #tree .entry span:hover + .branch .branch::before {
    border-color: #4f4f4f;
  }
</style>
